import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Accordion, AccordionDetails, AccordionSummary } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { ProductPrescriptionDialog } from '../../../product'

import { ProductPrescriptionTypeSelect } from './ProductPrescriptionTypeSelect'

export const ProductPrescriptionTypeCollapsible: FC = () => {
  const prescriptionDialogControls = useOpenableControls()

  return (
    <Accordion className="mb-5 tablet:mt-10">
      <AccordionSummary
        className="text-m font-bold text-dark-primary-max"
        data-qa-id="product-prescription-type-collapsible"
      >
        <FormattedMessage id="product.prescription.prescriptionAvailable" />
      </AccordionSummary>
      <AccordionDetails>
        <ProductPrescriptionTypeSelect className="w-full" />
        <button
          className="mt-3.5 font-bold text-dark-brand hover:underline"
          onClick={(): void => {
            prescriptionDialogControls.handleOpen()
          }}
          type="button"
        >
          <FormattedMessage id="product.prescription.howItWorks" />
        </button>
        {prescriptionDialogControls.isOpen ? (
          <ProductPrescriptionDialog
            isOpen={prescriptionDialogControls.isOpen}
            onClose={prescriptionDialogControls.handleClose}
          />
        ) : null}
      </AccordionDetails>
    </Accordion>
  )
}
